module.exports = __webpack_public_path__ + "static/media/1024297.d4e73f72.jpg";